document.addEventListener("DOMContentLoaded", (e) => {
  // Tab toggle for tabbed products section
  let tabs = document.querySelectorAll(".js-section-tab");

  if (tabs.length > 0 && !document.body.classList.contains("is-customiser")) {
    let tabSection = tabs[0].closest(".shopify-section"),
      indexSections = document.querySelectorAll(
        "#MainContent .shopify-section"
      ),
      sectionsAfterTab = [];

    if (indexSections.length > 1) {
      let addSection = false;

      indexSections.forEach((indexSection, index) => {
        addSection && sectionsAfterTab.push(indexSection);

        if (indexSection == tabSection) {
          addSection = true;
        }
      });
    }

    tabs.forEach((tab) => {
      tab.addEventListener("click", (e) => {
        let tabbedProductsEl = e.target
          .closest(".tabbed-content-blocks")
          .querySelector(
            `#tabbedProductsItem${e.target.dataset.index} [data-flickity]`
          );

        !!tabbedProductsEl &&
          setTimeout(() => window.Flickity.data(tabbedProductsEl).resize());

        hideSections(e.target);
      });
    });

    function hideSections(target) {
      let sectionsToHide = target.dataset.sectionsToHide.split(",");

      sectionsAfterTab.length &&
        sectionsAfterTab.forEach((section, index) => {
          section.classList.remove("!hidden");
          if (!!section.querySelector("[data-flickity]")) {
            let sectionFlickity = window.Flickity.data(
              section.querySelector("[data-flickity]")
            );
            sectionFlickity?.resize();
          }
          if (sectionsToHide.includes(`${index + 1}`))
            section.classList.add("!hidden");
        });
    }

    hideSections(tabs[0]);
  }
});
